<!-- src/views/Culture.vue -->
<template>
  <div class="culture">
    <Hero title="Culture" :imageUrl="heroImage" />
    <div class="container">
      <div class="articles">
        <ArticleCard
          v-for="article in articles"
          :key="article.id"
          :article="article"
          :section="'culture'"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Import the image
import heroImage from '@/assets/images/culture-hero.jpg';

import Hero from '@/components/Hero.vue';
import ArticleCard from '@/components/ArticleCard.vue';
import articles from '@/content/culture/articles.js';

export default {
  name: 'Culture',
  components: {
    Hero,
    ArticleCard,
  },
  data() {
    return {
      articles,
      heroImage, // Use the imported image
    };
  },
};
</script>

<style scoped>
/* Similar styles as in Explore.vue */
.articles {
  display: flex;
  flex-wrap: wrap;
}

.articles .article-card {
  flex: 1 1 calc(50% - 20px);
  margin: 10px;
}

@media (max-width: 768px) {
  .articles .article-card {
    flex: 1 1 100%;
  }
}
</style>